var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomepageUnknownPartnerLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 54,
    viewBox: "0 0 162 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.548 0.361328H149.015V53.3852H161.548V0.361328ZM105.098 12.246H93.2489V22.9094H103.804C114.31 22.9094 124.151 31.1309 124.151 43.3826V53.6396H136.33V43.3831C136.33 26.9496 123.096 12.246 105.098 12.246ZM84.7414 2.97263C84.7414 2.17046 84.6942 1.36695 84.6469 0.361328H71.7979C71.95 1.3674 71.8976 2.17046 71.8976 2.97263C71.8976 15.7742 61.5248 24.3594 50.4409 24.3594H39.3108V35.5069H51.8052C70.7913 35.5069 84.7414 20.1431 84.7414 2.97263ZM32.8981 53.4701L11.7738 26.6517L32.1445 0.361328H16.7162L0 21.5523V32.6008L16.716 53.4701H32.8981Z",
    fill: "#8F8F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageUnknownPartnerLogo);
export default __webpack_public_path__ + "static/media/HomepageUnknownPartnerLogo.fe07b36d93a86649192180d32abdb9d5.svg";
export { ForwardRef as ReactComponent };